import { PrimitiveValueObject } from '@/domain/primitiveValueObject';

export class FromId extends PrimitiveValueObject<string> {
  /**
   * 生成
   * @param value 値
   * @returns 値
   */
  static create(value: string): FromId {
    return new FromId(value);
  }

  /** 文字列にする */
  override toString() {
    return this.value;
  }
}
